import { render, staticRenderFns } from "./SwappTasksListMobileCard.vue?vue&type=template&id=3735d6b5&scoped=true"
import script from "./SwappTasksListMobileCard.vue?vue&type=script&lang=js"
export * from "./SwappTasksListMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735d6b5",
  null
  
)

export default component.exports